"use strict";

exports.__esModule = true;
exports.default = void 0;
var filterProps = function filterProps(props, filteredKeys) {
  return Object.keys(props).filter(function (key) {
    return !filteredKeys.includes(key);
  }).reduce(function (acc, key) {
    acc[key] = props[key];
    return acc;
  }, {});
};
var _default = exports.default = filterProps;